import axios, { AxiosInstance } from "axios";

const cdnClient: AxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_WIDGET_CDN_BASE_URL,
  headers: {
    "Cache-Control": "no-cache",
    Pragma: "no-cache",
  },
});

export default cdnClient;
